/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Fab, IconButton, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef, GridRowProps, GridRowsProp } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { deletedRequirement } from "src/stateManagement/redux/slices/location/asyncReducers";
import Swal from "sweetalert2";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import { AddActivity } from "./add_activity/AddActivity";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { ActiveActivityDto, RequirementDto } from "./add_activity/AddActivity";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { IUpdateDiagnosticForActivity } from "src/shared/util/updateDataServer";
import SearchIcon from '@mui/icons-material/Search';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import PublishIcon from '@mui/icons-material/Publish';
import WarningIcon from '@mui/icons-material/Warning';
import { getTranslationsForTable } from "src/shared/traslations";
import moment from "moment";
import { tableStyles } from "src/shared/util/tableStyles";

export const OptimizationActivities = ({
    originFieldActivityIdFromDiagnostic,
    activeDiagnostic,
    handleConvertToMain,
    addRemoveOptimizationActivity }: {
        originFieldActivityIdFromDiagnostic: string,
        handleConvertToMain: (activity: any) => void,
        addRemoveOptimizationActivity: (activity: any, remove: boolean) => void,
        activeDiagnostic?: IUpdateDiagnosticForActivity
    }) => {
    const { optimizationRequirements, locationId, locationName } = useSelector((state) => state.location);

    const [columns, setColumns] = useState<GridColDef[]>([])

    useEffect(() => {

        const optimizationActivitiesSelected = activeDiagnostic?.optimizationActivitiesSelected || [];

        setColumns([
            {
                field: "activity",
                headerName: "Tipo de Actividad",
                minWidth: 150,
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "requiredDate",
                headerName: "Fecha Solicitado ",
                minWidth: 100,
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "lastProduction",
                headerName: "Última medida Aceptada",
                minWidth: 100,
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "status",
                headerName: "Estado",
                minWidth: 100,
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "simulated",
                headerName: "Simulado",
                minWidth: 50,
                flex: 0.5,
                type: "boolean",
                headerAlign: "center",
                align: "center",
            },
            {
                field: "isWellWithMultiplesTDSEntries",
                headerName: "Repetitivo",
                headerAlign:"center", 
                align:"center", 
                minWidth: 50,
                flex: 0.5,
                renderCell: (params) => {
                    return params.row.isWellWithMultiplesTDSEntries ? (
                        <Grid
                            sx={{
                                display: "flex",
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 1,
                            }}
                        >
                            <WarningIcon color="warning" fontSize="small" />
                            <Typography color="warning">Si</Typography>
                        </Grid>
                    ) : (
                        <Grid
                            sx={{
                                display: "flex",
                                height: "100%",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 1,
                            }}
                        >
                            <Typography color="text.secondary">No</Typography>
                        </Grid>
                    );
                },
            },
            {
                field: "actions",
                headerName: "",
                headerAlign:"center", 
                align:"center" ,
                width: 120,

                renderCell: (params) => {
                    const id = `${params?.row?.optimizationActivityId}-${params?.row?.activity}`;

                    const selected = optimizationActivitiesSelected.find(
                        (item) => item.id === id
                    );

                    const isMain = optimizationActivitiesSelected.find(
                        (item) => item.id === id && item.main
                    );

                    return (
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {/* <IconButton
                                size="small"
                                color="info"
                                onClick={() => { }}
                            >
                                <SearchIcon fontSize="medium" />
                            </IconButton> */}
                            <Tooltip title={"Convertir en principal"}>
                                <IconButton
                                    onClick={() =>
                                        handleConvertToMain(params.row)
                                    }
                                >
                                    {isMain ? (
                                        <LooksOneIcon color="primary" />
                                    ) : (
                                        <PublishIcon color="disabled" />
                                    )}
                                </IconButton>
                            </Tooltip>
                            <IconButton
                                size="small"
                                color={selected ? "error" : "primary"}
                                onClick={() =>
                                    addRemoveOptimizationActivity(
                                        params.row,
                                        selected ? false : true
                                    )
                                }
                            >
                                {selected ? (
                                    <DeleteForeverIcon fontSize="medium" />
                                ) : (
                                    <AddCircleOutlineIcon fontSize="medium" />
                                )}
                            </IconButton>
                        </Grid>
                    );
                },
            },
        ]);
    }, [activeDiagnostic])

    const [dataToTable, setDataToTable] = useState<any[]>([])

    const [showAddRequirements, setShowAddRequirements] = useState(false);

    const [activeActivity, setActiveActivity] = useState<ActiveActivityDto | undefined>(undefined)

    useEffect(() => {
        const requirementsToTable = optimizationRequirements.map((item) => {
            return {
                ...item,
                simulated: item.simulationDate ? true : false,
            }
        })
        setDataToTable(requirementsToTable);

    }, [optimizationRequirements])

    const rows: GridRowsProp = dataToTable.map((item : any) => {
        return {
            variableId: item.variableId,
            optimizationActivityId: item.optimizationActivityId,
            activity: item.activity,
            blocker: item.blocker,
            comments: item.comments,
            executedDate: moment(item.executedDate).format("DD-MM-YYYY"),
            originFieldActivityExecutedDate: moment(
                item.originFieldActivityExecutedDate
            ).format("DD-MM-YYYY"),
            originFieldActivityId: item.originFieldActivityId,
            requiredBy: item.requiredBy,
            requiredById: item.requiredById,
            requiredDate: moment(item.requiredDate).format("DD-MM-YYYY"),
            simulated: item.simulated,
            status: item.status,
        };
    })

    const handleShowAddActivity = () => {
        setShowAddRequirements(!showAddRequirements);
    };

    const paginationModel = { page: 0, pageSize: 10 };

    const handleEditRow = (optimizationActivityid: string) => {


        const requirementsActivities = optimizationRequirements.filter(x => x.optimizationActivityId === optimizationActivityid)

        if (requirementsActivities.length === 0) return;

        const ActiveRequirements: RequirementDto[] = []

        requirementsActivities.forEach((item) => {
            const { variableId, activity, status, blocker, comments, simulationDate, lastProduction, targetProduction } = item;
            const requirement: RequirementDto = {
                id: variableId,
                location: locationName,
                name: activity,
                value: 'Si',
                type: 'Optimization',
                comments,
                blocker,
                status: status,
                simulationDate,
                lastProduction,
                targetProduction,
            };
            ActiveRequirements.push(requirement);
        });

        const activeActivity: ActiveActivityDto = {
            optimizationActivityId: requirementsActivities[0].optimizationActivityId,
            requirements: ActiveRequirements,
            requiredUserId: requirementsActivities[0].requiredById,
            requiredDate: requirementsActivities[0].requiredDate,
            originFieldActivityId: requirementsActivities[0].originFieldActivityId,
        }

        setActiveActivity(activeActivity);
        setShowAddRequirements(true);
    }


    return (
        <>
            {showAddRequirements && (
                <AddActivity
                    show={showAddRequirements}
                    setShowPendingActivities={setShowAddRequirements}
                    activeActivity={activeActivity}
                    setActiveActivity={setActiveActivity}
                    originFieldActivityIdFromDiagnostic={
                        originFieldActivityIdFromDiagnostic
                    }
                    TabDisable={true}
                />
            )}
            <Grid>
                <Grid size={12} sx={{ display: "flex", padding: 1 }}>
                    <DataGrid
                        rows={getTranslationsForTable([...rows], "es", [
                            "status",
                        ])}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        sx={{
                           
                            mt: 2,
                            ...tableStyles
                        }}
                        getRowId={(row) =>
                            row.optimizationActivityId + row.variableId
                        }
                    />
                </Grid>
                <Grid
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 2,
                    }}
                >
                    <Fab
                        size="medium"
                        color="primary"
                        aria-label="add"
                        onClick={handleShowAddActivity}
                    >
                        <AddIcon />
                    </Fab>
                </Grid>
            </Grid>
        </>
    );
};
